import "whatwg-fetch";
import "core-js/fn/array/find-index";
import "core-js/es6/promise";

import { HelloWorld } from "./components/HelloWorld";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Uploader } from "./components/Uploader";
import * as Config from "app-config";
import { fetchJson } from "./services/fileUpload";
import { InlineUploader } from "./components/InlineUploader";
import { Upload } from "./models/upload";

export const loadUploader = (
  resource: number,
  canDelete: boolean,
  canUpload: boolean,
  rootElement: Element
) => {
  ReactDOM.render(
    <Uploader
      resource={resource}
      canDelete={canDelete}
      canUpload={canUpload}
    />,
    rootElement
  );
};

export const loadInlineUploader = (
  upload: Upload | undefined,
  name: string,
  rootElement: Element
) =>
  ReactDOM.render(<InlineUploader upload={upload} name={name} />, rootElement);

export const beginUmbracoLogin = () =>
  fetchJson(Config.getSideLoginToken, undefined, "POST")
    .then(resp => {
      if (resp.ok) {
        return resp.json();
      }

      throw new Error(resp.statusText);
    })
    .then(data =>
      fetchJson(Config.sideLogin, data, "POST", {
        credentials: "include"
      })
    )
    .then(resp => {
      if (resp.ok) {
        window.location.href = Config.adminLogin;
      }
    })
    .catch(error => {
      console.error(error);
    });
